import React from 'react';
import {RawMaskedInput} from './type/RawMaskedInput';
import {InputWrapper} from './type/InputStructure';

export function MaskedInput({raw, ...props}) {
    if (raw) {
        return <RawMaskedInput {...props} />;
    } else {
        return <div>Error not available</div>;
    }
}

MaskedInput.Wrapper = InputWrapper;
export {InputWrapper};
